import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

// qr button
export const QrButton = ({ text, onClick = () => {} }) => {
  const { selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackage(
    multiLanguageData?.ClientWorkPackage || {}
  );
  const { TEXT_SCAN_QR_CODE } = LANGUAGE;
  const AccentColor = selectedClientData?.AccentColor;
  return (
    <Button
      startIcon={<QrCodeScannerIcon />}
      onClick={onClick}
      sx={{
        backgroundColor: AccentColor,
        color: "#fff"
      }}>
      {text || TEXT_SCAN_QR_CODE}
    </Button>
  );
};
